var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('div',{staticClass:"dashboard-text"},[_vm._v(" name:"+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"dashboard-text"},[_vm._v(" roles:"),_vm._l((_vm.roles),function(role){return _c('span',{key:role},[_vm._v(_vm._s(role))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }